import { render, staticRenderFns } from "./switchs.vue?vue&type=template&id=14944e74&"
import script from "./switchs.vue?vue&type=script&lang=ts&"
export * from "./switchs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "switchs.vue"
export default component.exports